module.exports = __webpack_public_path__ + "static/media/ford-map-hi.39001abe.png";